// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarPanelHeader__container-e1639e {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  height: 72px;
  padding: 0px 16px;
}

.SidebarPanelHeader__search-e1dc3c {
  margin-inline-end: 16px;
  flex: 1;
}

.SidebarPanelHeader__profile-d25d65 {
  border: 1px solid transparent;
  border-radius: 50%;
  cursor: pointer;
  padding: 1px;
  margin: 0px -2px;
}

.SidebarPanelHeader__profile-d25d65:hover,
.SidebarPanelHeader__profile-d25d65:focus {
  border-color: var(--base-90);
}

.SidebarPanelHeader__profile-d25d65:active {
  border-color: var(--base-100);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SidebarPanelHeader/SidebarPanelHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;EACA,OAAA;AACF;;AAEA;EACE,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,4BAAA;AACF;;AAEA;EACE,6BAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  height: 72px;\n  padding: 0px 16px;\n}\n\n.search {\n  margin-inline-end: 16px;\n  flex: 1;\n}\n\n.profile {\n  border: 1px solid transparent;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 1px;\n  margin: 0px -2px;\n}\n\n.profile:hover,\n.profile:focus {\n  border-color: var(--base-90);\n}\n\n.profile:active {\n  border-color: var(--base-100);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SidebarPanelHeader__container-e1639e`,
	"search": `SidebarPanelHeader__search-e1dc3c`,
	"profile": `SidebarPanelHeader__profile-d25d65`
};
module.exports = ___CSS_LOADER_EXPORT___;
